/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/without.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Groups by all time-series dimensions except the specified ones. When called with no arguments, groups by all dimensions.',
  examples: [
    'TS k8s\n| STATS total_cost = sum(network.cost) BY WITHOUT(pod)\n| SORT total_cost',
    'TS k8s\n| STATS total_cost = sum(network.cost) BY WITHOUT(pod, region)\n| SORT total_cost',
    'TS k8s\n| STATS total_cost = sum(network.cost) BY WITHOUT()\n| SORT total_cost',
  ],
  params: {
    dimension: '(Optional) One or more [time series dimension](docs-content://manage-data/data-store/data-streams/time-series-data-stream-tsds.md#time-series-dimension) fields to exclude from the time series grouping. Must be dimension fields of the index (not metrics, not regular fields). When called with no arguments, groups by all dimensions.',
  },
};

export default docs;
